<life-di-nav></life-di-nav>

<div class="container my-5">
  <div class="row justify-content-center py-4 px-4 mt-4" style="background-color: #fcfcfc;">
    <h1 class="mt-2 mb-4">
      <b class="text-center lifedi-color">นโยบายความเป็นส่วนตัว</b>
    </h1>
    <div class="row">
      <div class="container">
        <p class="col-12">
          - โครงการในเว็บไซต์นี้เป็นโครงการวิจัย ไม่ใช่ การรักษาตามปกติ <br/>
          - การเข้าร่วมการวิจัยนี้ขึ้นอยู่กับความสมัครใจ
          ท่านสามารถตัดสินใจได้อย่างอิสระว่าจะเข้าร่วมหรือไม่เข้าร่วมการวิจัยนี้
          ท่านไม่จำเป็นจะต้องเข้าร่วมในโครงการวิจัยนี้ <br/>
          - นักวิจัยผู้ขอความยินยอมต้องให้ ข้อมูลและเวลาที่เพียงพอ ในการตัดสินใจอย่างอิสระ
          ก่อนที่ท่านจะเข้าร่วมโครงการวิจัย <br/>
          - ท่านสามารถซักถามข้อสงสัยเกี่ยวกับโครงการวิจัยได้
          ซึ่งผู้วิจัยจะอธิบายเพิ่มเติมแก่ท่านและตอบข้อซักถามจนท่านเข้าใจ <br/>
          - หากท่านสมัครใจเข้าร่วมการวิจัยนี้แล้ว ท่านยังคงสามารถถอนตัวออกจากการวิจัยได้ทุกเมื่อ
          โดยจะไม่มีผลกระทบต่อคุณภาพการบริการหรือการรักษาพยาบาลที่ท่านพึงได้รับตามสิทธิ <br/>
          - ระบบจะเก็บข้อมูลส่วนตัวของผู้ใช้ เช่น email, ชื่อโปรไฟล์, เพศ, วันเดือนปีเกิด เพื่อใช้ในการจำแนกประเภทผู้ใช้งาน
          และเพื่อส่งมอบเนื้อหาที่เหมาะสมให้กับผู้ใช้งาน <br/>
          - ผู้ใช้งานสามารถลบบัญชี(ข้อมูลส่วนตัว)ได้โดยไปที่หน้า profile > ลบบัญชีผู้ใช้
        </p>
      </div>
    </div>
  </div>
</div>
<lifedi-footer></lifedi-footer>
